import React from "react";
import { Box } from "@mui/material";
import { useDrag } from "react-dnd";

export const ITEM_TYPE_TOOL = "TOOL";

function ToolItem({ tool }) {
  const [{ isDragging }, dragRef] = useDrag(() => ({
    type: ITEM_TYPE_TOOL,
    item: { tool_name: tool.tool_name },
    collect: (monitor) => ({ isDragging: monitor.isDragging() })
  }));

  return (
    <Box
      ref={dragRef}
      sx={{
        padding: "8px 12px",
        margin: "8px 0",
        backgroundColor: "#fff8e1",
        border: "1px solid #ffd54f",
        borderRadius: "4px",
        cursor: "move",
        opacity: isDragging ? 0.5 : 1
      }}
    >
      {tool.tool_name}
    </Box>
  );
}

export default ToolItem;
